import produce from 'immer';
import objFromArray from 'src/utils/objFromArray';
import {
  UPDATE_AGENT_STATUS,
  AGENT_CONNECTED,
  AGENT_DISCONNECTED,
  SET_AGENT_STATUS_LIST
} from 'src/actions/agentActions';

const initialState = {
  allIds: [],
  byId: {},
  connectedAgents: []
};

const agentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AGENT_STATUS_LIST: {
      const { agents } = action.payload;
      return produce(state, draft => {
        draft.byId = objFromArray(agents, 'staffId');
        draft.allIds = Object.keys(draft.byId);
        draft.connectedAgents = agents
          .filter(agent => agent.isConnected && agent.status === 'available')
          .map(agent => agent.staffId);
      });
    }

    case UPDATE_AGENT_STATUS: {
      const { staffId, status, isConnected, lastStatusChange } =
        action.payload;
      return produce(state, draft => {
        if (draft.byId[staffId]) {
          draft.byId[staffId].status = status;
          if (typeof isConnected === 'boolean') {
            draft.byId[staffId].isConnected = isConnected;
          }
          draft.byId[staffId].lastStatusChange =
            lastStatusChange || Date.now();

          // Update connectedAgents list based on new status
          const connectedIndex = draft.connectedAgents.indexOf(staffId);
          if (status === 'available' && draft.byId[staffId].isConnected) {
            // Add to connected agents if available and connected
            if (connectedIndex === -1) {
              draft.connectedAgents.push(staffId);
            }
          } else {
            // Remove from connected agents if not available
            if (connectedIndex > -1) {
              draft.connectedAgents.splice(connectedIndex, 1);
            }
          }
        }
      });
    }

    case AGENT_CONNECTED: {
      // Handle both old format (agent object) and new format (individual properties)
      const agentData = action.payload.agent || {
        staffId: action.payload.staffId,
        username: action.payload.username,
        avatar: action.payload.avatar,
        status: action.payload.status,
        isConnected: action.payload.isConnected,
        lastStatusChange: action.payload.lastStatusChange
      };

      return produce(state, draft => {
        draft.byId[agentData.staffId] = {
          ...agentData,
          isConnected: true,
          lastStatusChange: Date.now()
        };

        if (!draft.allIds.includes(agentData.staffId)) {
          draft.allIds.push(agentData.staffId);
        }

        // Only add to connectedAgents if status is available
        if (
          agentData.status === 'available' &&
          !draft.connectedAgents.includes(agentData.staffId)
        ) {
          draft.connectedAgents.push(agentData.staffId);
        }
      });
    }

    case AGENT_DISCONNECTED: {
      const { staffId } = action.payload;
      return produce(state, draft => {
        if (draft.byId[staffId]) {
          draft.byId[staffId].isConnected = false;
          draft.byId[staffId].status = 'offline'; // Ensure status is set to offline
          draft.byId[staffId].lastStatusChange = Date.now();
        }

        const connectedIndex = draft.connectedAgents.indexOf(staffId);
        if (connectedIndex > -1) {
          draft.connectedAgents.splice(connectedIndex, 1);
        }
      });
    }

    default: {
      return state;
    }
  }
};

export default agentReducer;
